import { Observable } from "rxjs";
import { TemplateRef } from "@angular/core";

export interface TypeAheadConfig<T> {
  searchFn: (term: string) => Observable<T[]>;
  displayFn: (item: T) => string;
  valueFn: (item: T) => any;
  minLength?: number;
  debounceTime?: number;
  placeholder?: string;
  notFoundText?: string;
  itemTemplate?: TemplateRef<any>;
  ariaLabel?: string;
  dropdownClass?: string;
  dropdownWidth?: string;  // e.g., '300px', '100%', '20rem'
  dropdownMaxHeight?: string;  // e.g., '300px', '20rem'
  dropdownPosition?: 'left' | 'right' | 'center';  // Controls dropdown alignment
  showSearchIcon?: boolean;  // Whether to show the search icon
  customIcon?: string;  // Custom icon class (e.g., 'fa fa-search' for Font Awesome)
  iconPosition?: 'left' | 'right';  // Position of the icon
  onItemClick?: (item: T, event: MouseEvent) => void;  // Optional click handler for dropdown items
  clearOnSelect?: boolean;
  multiSelect?: boolean; // Enable multi-select mode
}

export interface TypeAheadOption<T> {
  item: T;
  displayText: string;
  index?: number;
}

export enum KeyboardKeys {
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  Enter = 'Enter',
  Escape = 'Escape'
} 